import { InvestorsPageTemplate } from '@/pageTemplate/InvestorsPageTemplage';
// import { GetStaticProps } from 'next';
import { DocsProps, DocumentList } from '@/components/investors/DocumentList';
import { SeoProps } from '@/components/shared/SEO';
import { Flex } from '@lemonade-hq/cdk';
import SECFilingsTableQ4 from '@/components/investors/SECFilingsTableQ4';
import { MediumSmallTitle } from '@/components/investors/shared';

const DOCS = [
  {
    file: `${process.env.NEXT_PUBLIC_INVESTOR_ASSETS_URL}/reports/LMND-2025-Proxy-Statement-Final-4-23-25.pdf`,
    name: '2025 Proxy Statement',
  },
  {
    file: `${process.env.NEXT_PUBLIC_INVESTOR_ASSETS_URL}/reports/LMND-2024-Annual-Report-Final-4-23-25.pdf`,
    name: '2024 Annual Report',
  },
] as DocsProps['docs'];

const FinancialDocuments = () => {
  return (
    <Flex flexDirection="column" gap="18px" mt="10px">
      <MediumSmallTitle>Annual Reports and Proxy</MediumSmallTitle>
      <DocumentList docs={DOCS} />
    </Flex>
  );
};

const MAX_WIDTH = 800;

const seo = {
  title: 'Lemonade Inc. - Filings',
  description:
    'Access Lemonade’s SEC filings and financial disclosures for details on our company’s compliance, performance, and regulatory reporting.',
} as SeoProps;

export default function SecFilingsPage() {
  return (
    <InvestorsPageTemplate seo={seo}>
      <Flex flexDirection="column" width="100%" maxWidth={MAX_WIDTH} gap="20px">
        <Flex flexDirection="column" gap="20px" px={[20, 20, 0]} width="100%">
          <FinancialDocuments />
        </Flex>
        {/* <SECFilingsTable filings={filings} cik={cik} uniqueYears={uniqueYears} /> */}
        <SECFilingsTableQ4 />
      </Flex>
    </InvestorsPageTemplate>
  );
}
